import { omniAtom } from "src/utils/atoms";
import type { ResponsePutMerchflows_merchflowId_ } from "@CommonApi/merchflows/_merchflowId_";

export interface MerchflowNotesModalData {
  merchflowId: number;
  notes: string;
  onSave?: (notes: string, response: ResponsePutMerchflows_merchflowId_) => void;
}

export const merchflowNotesModalAtom = omniAtom<MerchflowNotesModalData | null>({
  key: "modals/merchflowNotes",
  value: null,
});
